import { makeDataObjGenerator } from 'mocks/helpers'
import {
  AddressTypeEnum,
  PlayingDoubleHandEnum,
  PlayingHandEnum,
  SexEnum,
  WorldTennisNumberTypeEnum,
} from 'types/api/enums'
import { PersonAPI } from 'types/api/types'
import { createGqlResponseTransformer } from 'utils/test-utils'

const defaultData = {
  id: '614c4017f60ae6bf2379793a1',
  nativeGivenName: 'John',
  nativeFamilyName: 'Snow',
  birthDate: '1990-07-20',
  age: 31,
  birthYear: 0,
  tennisID: 'TES123456',
  nationalID: '',
  sex: SexEnum.M,
  nationalityCode: 'ITA',
  optedOutOfPublicDataConsent: false,
  isRanked: false,
  eligibleForSelfSubmission: true,
  eligibleForPsq: true,
  addresses: [
    {
      addressType: AddressTypeEnum.HOME,
      city: 'Test City',
      countryCode: 'ITA',
      state: 'TC',
      __typename: 'Address',
    },
  ],
  biographicalInformation: {
    placeOfResidence: 'GBR',
    playingHand: PlayingHandEnum.R,
    doublePlayingHand: PlayingDoubleHandEnum.FB,
    weightInKgs: 79.2,
    heightInMeters: 1.79,
    avatarUrl:
      'https://stg0itf0cspark.blob.core.windows.net/itf/User/734e5d18-3c59-44c4-96ed-46a07917a8d2/Photos/071eac68-4751-4296-903d-3ef566c2f153.png',
    favouriteShot: '',
    residenceCountryCode: 'ITA',
    __typename: 'BiographicalInformation',
  },
  worldTennisNumbers: [
    {
      type: WorldTennisNumberTypeEnum.DOUBLE,
      tennisNumber: 24.81,
      confidence: 0.6,
      __typename: 'WorldTennisNumber',
    },
    {
      type: WorldTennisNumberTypeEnum.SINGLE,
      tennisNumber: 24.02,
      confidence: 0.7,
      __typename: 'WorldTennisNumber',
    },
  ],
  lastPlayedSingles: '2021-07-21T00:00:00.000Z',
  lastPlayedDoubles: '2021-07-21T00:00:00.000Z',
  hasSubmittedResult: false,
  __typename: 'Person',
} as unknown as PersonAPI

export const createProfile = makeDataObjGenerator(defaultData)

export const getProfile = createGqlResponseTransformer('person', 'Person', defaultData)
